import { DatePipe, Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-manage-shift-details',
  templateUrl: './manage-shift-details.component.html',
  styleUrls: ['./manage-shift-details.component.scss'],
  providers: [DatePipe]
})

export class ManageShiftDetailsComponent implements OnInit {
  dateFormat: any = null;
  @Input() shiftDetails: any;
  @Output() publishOpenShiftEmitter = new EventEmitter();

  manageScheduleForm!: FormGroup;
  currentDate = new Date();
  minDate: Date;
  isEditable = false;
  driverId: any = null;
  schedulesDate: Date = null;
  schedulesUserList: any = null;
  lastName: any = null;
  firstName: any = null;
  defaultTimezone: any = null;
  title: any = null;
  userSchedules: any = [];
  tempUserSchedules: any = [];
  marketsList: any[] = [];
  items: any = [];
  filterDate;
  userRoleId;
  isPreviousDate = false;
  minuteArray: number[] = [0, 15, 30, 45];
  newArry: any = [];
  nextDate: number;
  filterNextDate: string;
  newArry2: any = [];
  teamId: any;
  isSlotEmpty = false;
  proId: any;
  hasShowManageShiftPopUp = false;
  teamList: any[] = [];
  titleList: any[] = [];
  team: any;
  teamName: any;
  scheduleObject: any;
  isSaveEnable = false;
  availableStartTime: Date;
  availableEndTime: Date;
  dateCalender: Date;
  notesChange;
  isDisable = false;
  isWebPortalUser = false;
  originalFilterDate: string;
  leaveTypeList: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private manageOpenShiftsService: ManageOpenShiftsService,
    private commonBindingDataService: CommonBindingDataService,
    private location: Location,
    private formBuilder: FormBuilder,
    private uiService: UiService,
    private commonService: CommonBindingDataService,
    private datePipe: DatePipe,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.dateFormat = this.commonBindingDataService.getDateFormat();
    this.driverId = this.shiftDetails.userId;
    this.minDate = this.shiftDetails.date;
    this.nextDate = new Date(this.minDate).setDate(new Date(this.minDate).getDate() + 1),
      this.schedulesDate = this.minDate;
    this.dateCalender = new Date(this.shiftDetails.date);

    this.manageScheduleForm = this.setFormData();
    const userType = this.shiftDetails?.userType;
    this.isWebPortalUser = userType === 'Web' || userType === '20' || userType === 'Web Portal';
    this.loadLeaveTypes();
    this.proId = sessionStorage.getItem('providerId');
    this.filterDate = moment(this.minDate).format('MM/DD/YYYY');
    this.originalFilterDate = this.filterDate;
    this.filterNextDate = moment(this.nextDate).format('MM/DD/YYYY');
    this.titleList.push({ label: this.commonService.getLabel('please_select'), value: '' });
    this.getTeam();
    this.currentDate = this.commonBindingDataService.addOneHourToCurrentTime();
  }

  setFormData(): FormGroup {
    return this.formBuilder.group({
      items: this.formBuilder.array([]),
    });
  }

  addSchedule(scheduleModel: any): FormGroup {
    return this.formBuilder.group({
      availableFrom: [scheduleModel ? new Date(new Date().setHours(0, 0, 0, 0) + scheduleModel.availableFrom) : '', [Validators.required]],
      availableTo: [scheduleModel ? new Date(new Date().setHours(0, 0, 0, 0) + scheduleModel.availableTo) : '', [Validators.required]],
      team: [scheduleModel && scheduleModel.team ? String(scheduleModel.team) : (this.teamName ? String(this.teamName) : '')],
      notesChange: [scheduleModel ? scheduleModel.notes : this.notesChange]
    });
  }

  addItem(scheduleModel?: any): void {
    // this.isSaveEnable = true;
    this.items = this.manageScheduleForm.get('items') as FormArray;
    this.items.push(this.addSchedule(scheduleModel));
  }

  removeItem(index, scheduleId, leaveType) {
    if (leaveType) {
      this.cancelLeave(scheduleId, index);
      this.userSchedules.splice(index, 1);
      // this.isSaveEnable = true;
    } else {
      this.isSaveEnable = true;
      this.items.removeAt(index);
      this.userSchedules.splice(index, 1);
    }
  }

  cancelLeave(scheduleId, index) {
    this.manageOpenShiftsService.cancelMemberLeave(scheduleId).subscribe((res) => {
      this.uiService.showMessage(res.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.isSaveEnable = true;
      this.items.removeAt(index);
      // this.userSchedules[index].leaveType = null;
      // this.userSchedules[index].leaveTypeId = null;
      // this.getSchedulesUserList(this.driverId, this.shiftDetails?.date);
      // this.cancelLeaveEmitter.emit(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  updateSchedular() {
    this.isDisable = true;
    this.syncFilterDatesFromCalendar();
    const scheduleForDay = this.manageScheduleForm.controls.items.value;

    let finalScheduleArray = [];
    let data;
    this.newArry = [];
    this.newArry2 = [];
    scheduleForDay.forEach((element, index) => {
      if ((this.team === '' || this.team === undefined) && this.teamName) {
        this.teamName = this.teamName;
      } else {
        this.teamName = this.team ? this.team : '';

      }
     // this.notesChange = this.userSchedules[index]?.notes;
      if (element.availableFrom.getHours() > element.availableTo.getHours()) {
        finalScheduleArray.push({
          startTimeStr: moment(element.availableFrom).format('hh:mm A'),
          endTimeStr: '11:59 PM',
          teamId: element?.team,
          providerId: this.proId,
          notes: element.notesChange,
          fullDayOff: this.userSchedules[index]?.fullDayOff ? this.userSchedules[index]?.fullDayOff : false,
          leaveTypeId: this.userSchedules[index]?.leaveTypeId ? this.userSchedules[index]?.leaveTypeId : null,
          source: this.userSchedules[index]?.source ? this.userSchedules[index]?.source : null,
        });
        data = {
          date: this.filterDate,
          userRoleId: this.userRoleId,
          userSchedules: finalScheduleArray
        };
        this.newArry.push(data);
        data = {};
        finalScheduleArray = [];

        finalScheduleArray.push({
          startTimeStr: '12:00 AM',
          endTimeStr: moment(element.availableTo).format('hh:mm A'),
          teamId: element?.team,
          providerId: this.proId,
          notes: element.notesChange,
          fullDayOff: this.userSchedules[index]?.fullDayOff ? this.userSchedules[index]?.fullDayOff : false,
          leaveTypeId: this.userSchedules[index]?.leaveTypeId ? this.userSchedules[index]?.leaveTypeId : null,
          source: this.userSchedules[index]?.source ? this.userSchedules[index]?.source : null
        });
        data = {
          date: this.filterNextDate,
          userRoleId: this.userRoleId,
          userSchedules: finalScheduleArray,
        };

        this.newArry.push(data);

      } else {
        this.newArry2 = [];
        finalScheduleArray.push({
          startTimeStr: moment(element.availableFrom).format('hh:mm A'),
          endTimeStr: moment(element.availableTo).format('hh:mm A'),
          teamId: element?.team,
          providerId: this.proId,
          notes: element.notesChange,
          fullDayOff: this.userSchedules[index]?.fullDayOff ? this.userSchedules[index]?.fullDayOff : false,
          leaveTypeId: this.userSchedules[index]?.leaveTypeId ? this.userSchedules[index]?.leaveTypeId : null,
          source: this.userSchedules[index]?.source ? this.userSchedules[index]?.source : null
        });

        data = {
          date: this.filterDate,
          userRoleId: this.userRoleId,
          userSchedules: finalScheduleArray
        };
        this.newArry2.push(data);
      }

    });
    const presentArray = [];
    const arr: any = Array.from(new Set(this.newArry2.concat(this.newArry).map(JSON.stringify)));
    arr.forEach(item => {
      presentArray.push(JSON.parse(item));
    });
    this.scheduleObject = { 'userSchedulesResponses': presentArray };
    const hasMovedSchedule = this.originalFilterDate && this.originalFilterDate !== this.filterDate;

    const saveSchedule = () => {
      this.manageOpenShiftsService.updateDriverSchedule(this.driverId, this.scheduleObject).subscribe(result => {
        this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
        this.getSchedulesUserList(this.driverId, this.schedulesDate);
        this.publishOpenShiftEmitter.emit(true);
      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        this.isDisable = false;
        if (error.general[0].messageCode === 'error.providerIsBusyWithAppointment') {
          this.getSchedulesUserList(this.driverId, this.schedulesDate);
        }
      });
    };

    if (hasMovedSchedule) {
      this.manageOpenShiftsService.deleteDriverSchedule(this.driverId, this.originalFilterDate).subscribe(() => {
        saveSchedule();
      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        this.isDisable = false;
      });
      return;
    }

    saveSchedule();
  }

  deleteSchedule(event?: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the user shift and time off?',
      header: 'Confirmation',
      accept: () => {
        this.manageOpenShiftsService.deleteDriverSchedule(this.driverId, this.filterDate).subscribe(result => {
          this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          this.isEditable = false;
          this.getSchedulesUserList(this.driverId, this.schedulesDate);
          this.publishOpenShiftEmitter.emit(true);
          this.isSaveEnable = false;
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
          this.isSaveEnable = true;
        });
      }
    });
  }

  editSchedule(event?: any) {
    this.isSaveEnable = true;
    this.isEditable = true;
  }

  onCancel() {
    this.publishOpenShiftEmitter.emit(true);
  }

  getSchedulesUserList(driverId, date) {
    const dateInMilisec = moment(this.dateCalender).format('MM/DD/YYYY');
    // this.isEditable = isEditable_flag;
    this.manageOpenShiftsService.getSchedulesUserList(this.shiftDetails.userId, dateInMilisec).subscribe(result => {
      this.schedulesUserList = result;
      this.firstName = result.firstName;
      this.lastName = result.lastName;
      this.title = result.title;
      this.teamName = this.schedulesUserList?.userSchedules[0]?.teamId || '';
      this.userSchedules = result.userSchedules
        ? result.userSchedules.map((schedule) => this.normalizeSchedule(schedule))
        : [];
      this.tempUserSchedules = this.userSchedules;
      this.userRoleId = result.userRoleId;
      this.manageScheduleForm = this.setFormData();
      this.items = this.formBuilder.array([]);
      const popIndex = [];
      if (result.userSchedules) {
        result.userSchedules.forEach((element, i) => {

          const scheduleModel = {
            availableFrom: element.availableFrom,
            availableTo: element.availableTo,
            team: element.teamId ? String(element.teamId) : '',
            notes: element.notes
          };
          // this.isSlotEmpty = !element.availableFrom &&  !element.availableTo
          if (element.availableFrom || element.availableTo) {
            this.addItem(scheduleModel);
          } else {
            popIndex.push(i);
            // this.tempUserSchedules = [];
            // this.tempUserSchedules  = this.tempUserSchedules.filter((element) => element.availableFrom || element.availableTo )
          }
        });
        if (popIndex.length > 0) {
          // sort to avoid index changing on splicing
          popIndex.sort((a, b) => b - a);

          popIndex.forEach(index => {
            this.userSchedules.splice(index, 1);
          });
          // this.tempUserSchedules = []
          // this.userSchedules = this.userSchedules.filter(( obj, index) => !popIndex.includes(index));
        }
      }
      this.getTimezone(result.firstName);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  onSelectSchedulesDate(event: any) {
    const startDate = event;
    if (startDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
      this.isPreviousDate = true;
    } else {
      this.isPreviousDate = false;
    }
    this.filterDate = moment(event).format('MM/DD/YYYY');
    this.nextDate = new Date(this.filterDate).setDate(new Date(this.filterDate).getDate() + 1),
      this.filterNextDate = moment(this.nextDate).format('MM/DD/YYYY');
    this.getSchedulesUserList(this.driverId, startDate);
  }

  setFullName(user) {
    let fullName = '';
    if (user.firstName) { fullName += user.firstName; }
    if (user.lastName) { fullName += ' ' + user.lastName; }
    if (user.title) { fullName += ', ' + user.title; }
    return fullName;
  }

  goBack() {
    this.location.back(); // <-- go back to previous location
  }

  getTimezone(data) {
    this.commonService.getMarketsList('market-timezones').subscribe(results => {
      this.marketsList = results;
      this.marketsList.filter(obj => {
        if (obj.marketName === data) {
          this.defaultTimezone = obj.timezoneAbbr;
        }
      });
    }, (error) => {
    });
  }

  getTeam() {
    this.teamList.push({ label: this.commonService.getLabel('Select'), value: '' });
    this.manageOpenShiftsService.getTeam(this.shiftDetails?.providerId).subscribe((result) => {
      for (let i = 0; i < result.length; i++) {
        this.teamList.push({ label: result[i].teamName, value: String(result[i].id) });
      }
      this.getSchedulesUserList(this.driverId, this.minDate);
    }, (error) => {
    });
  }

  getTime(event: any, i: number) {
    const hour = moment(event.value?.availableFrom).format('hh:mm A').split(':');
    const time = this.commonBindingDataService.timeAdjustment(hour);
    const startTime = new Date(`1970-01-01 ${time}`).toISOString();
    // this.items.at(i).get('availableFrom').setValue(startTime);
  }

  getEndTime(event: any, i: number) {
    const hour1 = moment(event.value.availableTo).format('hh:mm A');
    const hour = moment(event.value.availableTo).format('hh:mm A').split(':');
    if (hour1 !== '11:59 PM') {
      const time = this.commonBindingDataService.timeAdjustment(hour);
      const endTime = new Date(`1970-01-01 ${time}`).toISOString();
      // this.items.at(i).get('availableTo').setValue(endTime);
    }

  }

  onDateChange(event: Date) {
    if (event) {
      this.dateCalender = event;
      this.syncFilterDatesFromCalendar();
      this.getSchedulesUserList(this.driverId, this.dateCalender);
    }
  }

  private syncFilterDatesFromCalendar(): void {
    if (!this.dateCalender) {
      return;
    }

    this.filterDate = moment(this.dateCalender).format('MM/DD/YYYY');
    const nextDate = new Date(this.dateCalender);
    nextDate.setDate(nextDate.getDate() + 1);
    this.nextDate = nextDate.getTime();
    this.filterNextDate = moment(nextDate).format('MM/DD/YYYY');
    this.schedulesDate = new Date(this.dateCalender);
  }
  onNotesChange(event: Event, index: number) {

    const itemsArray = this.manageScheduleForm.get('items') as FormArray;
    const itemControl = itemsArray.at(index) as FormGroup;
    this.notesChange = itemControl.get('notesChange')?.value;
  }

  loadLeaveTypes() {
    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA) as { leave_type?: { tagValue: string; tagId: any }[] } | null;
    const localTagData = JSON.parse(localStorage.getItem('localTagdata') || '{}') as { leave_type?: { tagValue: string; tagId: any }[] };
    const leaveTypes = tagsData?.leave_type || localTagData?.leave_type || [];
    leaveTypes.forEach((element) => {
      this.leaveTypeList.push({ label: element.tagValue, value: element.tagId });
    });
  }

  isLeaveSchedule(schedule: any): boolean {
    return !!(schedule?.leaveType || this.isLeaveTypeId(schedule?.leaveTypeId));
  }

  getLeaveTypeLabel(schedule: any): string {
    if (schedule?.leaveType) {
      return schedule.leaveType;
    }
    const matchedLeaveType = this.leaveTypeList.find(
      (leaveType) => String(leaveType.value) === String(schedule?.leaveTypeId)
    );
    return matchedLeaveType?.label || schedule?.leaveTypeStr || 'PTO';
  }

  get leaveNotesIndex(): number {
    return this.userSchedules.findIndex((schedule) => this.isLeaveSchedule(schedule));
  }

  private isLeaveTypeId(leaveTypeId: any): boolean {
    return leaveTypeId != null && leaveTypeId !== '' && String(leaveTypeId) !== '0';
  }

  private normalizeSchedule(schedule: any): any {
    if (!schedule.leaveType && this.isLeaveTypeId(schedule.leaveTypeId)) {
      schedule.leaveType = this.getLeaveTypeLabel(schedule);
    }
    return schedule;
  }
}
